import { useMutation, UseMutationResult } from 'react-query';

import { getTokenWithType } from './useAuth';
import { checkChoiceWithLimitedAccess } from 'utils/urls';

import { ErrorModal } from 'types/modalTypes';

type TError = ErrorModal;

type TResult = {
  Data: string[];
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

type TVariables = number[];
type TSnapshot = unknown;

async function checkLimitedAcessPersist(params: TVariables): Promise<TResult> {
  const response = await fetch(checkChoiceWithLimitedAccess, {
    method: 'POST',
    headers: {
      Authorization: getTokenWithType(),
      'content-type': 'application/json',
    },
    body: JSON.stringify(params),
  });

  return response.json();
}

function useValidateLimitedAccessChoice(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  return useMutation((params: TVariables) => checkLimitedAcessPersist(params));
}

export { useValidateLimitedAccessChoice };
